import { motion } from "framer-motion";
import { heatColor } from "../lib/heat";

interface Props {
  value: number; // 0..1
  height?: number;
  pulse?: boolean;
}

export function HeatBar({ value, height = 6, pulse }: Props) {
  const clamped = Math.max(0, Math.min(1, value));
  const widthPct = Math.pow(clamped, 0.7) * 100;
  return (
    <div
      className="w-full rounded-full overflow-hidden bg-white/5 relative"
      style={{ height }}
    >
      <motion.div
        className={`h-full rounded-full ${pulse ? "animate-pulseGlow" : ""}`}
        style={{ background: `linear-gradient(90deg, hsla(220,80%,55%,0.4), ${heatColor(clamped)})` }}
        initial={{ width: 0 }}
        animate={{ width: `${widthPct}%` }}
        transition={{ type: "spring", stiffness: 90, damping: 18 }}
      />
    </div>
  );
}
